import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { empty, Observable, throwError } from 'rxjs';
import {
  IOrderInquiry, IGetInvoiceBody, IInvoiceInquiry,
  IGetOrderInvoiceDetailsBody, IGetOrderShipmentDetailsBody, IUser,
  IGetOrdersInquiryBody, IGetOrdersDetailsBody, ICustomer, IGetInvoiceDetailsBody,
  BaseResponse, FreightOrder, FreightClaimHeader,
  FreightClaimDetails, FreightClaimItem
} from '../models';
import { ApiService } from './api.service';
import { ConfigService } from './config.service';
import { catchError, map, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FreightClaimService {
  claimHeaderId: string;

  constructor(private httpClient: HttpClient) { }

  public apiBaseUrl() {
    return environment.apiUrl;
  }

  public get readUserObject(): IUser {
    return JSON.parse(localStorage.getItem('user')) as IUser;
  }

  selectedOrder: FreightOrder;

  public getInitData(): Observable<any> {
    let customerNumber = this.readUserObject.customerNumber;
    const endPoint = '/freightClaim/GetInitData';// `${ConfigService.APIs.endPoints.FREIGHT_CLAIM.GET_MY_SHIPPED_ORDERS}` + "\\" + customerNumber;
    return ApiService.genericObservableGet(this.httpClient, endPoint)
      .pipe(
        catchError((err, caught) => { return throwError(err); }),
        map((response: BaseResponse) => response.data)
      );
  }

  public getOrders(body: IGetOrdersInquiryBody): Observable<Array<IOrderInquiry>> {
    let customerNumber = this.readUserObject.customerNumber;
    const endPoint = '/freightClaim/getMyShippedOrders/' + customerNumber;// `${ConfigService.APIs.endPoints.FREIGHT_CLAIM.GET_MY_SHIPPED_ORDERS}` + "\\" + customerNumber;
    return ApiService.genericObservableGet(this.httpClient, endPoint)
      .pipe(
        catchError((err, caught) => { return throwError(err); }),
        map((response: BaseResponse) => response.data)
      );
  }

  public loadClaimMasterData(): Observable<Array<IOrderInquiry>> {
    const endPoint = '/freightClaim/getMasterData';// `${ConfigService.APIs.endPoints.FREIGHT_CLAIM.GET_MY_SHIPPED_ORDERS}` + "\\" + customerNumber;
    return ApiService.genericObservableGet(this.httpClient, endPoint)
      .pipe(
        catchError((err, caught) => { return throwError(err); }),
        map((response: BaseResponse) => response.data)
      );
  }


  public getMyClaims(): Observable<Array<FreightClaimHeader>> {
    let customerNumber = this.readUserObject.customerNumber;
    let userId = this.readUserObject.userId;
    const endPoint = '/FreightClaim/GetMyClaims/' + userId + '/' + customerNumber;// `${ConfigService.APIs.endPoints.FREIGHT_CLAIM.GET_MY_SHIPPED_ORDERS}` + "\\" + customerNumber;
    return ApiService.genericObservableGet(this.httpClient, endPoint)
      .pipe(
        catchError((err, caught) => { return throwError(err); }),
        map((response: BaseResponse) => response.data)
      );
  }


  public getMyClaimsDetails(claimId): Observable<FreightClaimHeader> {
    let customerNumber = this.readUserObject.customerNumber;
    let userId = this.readUserObject.userId;
    const endPoint = '/FreightClaim/GetClaimDetails/' + claimId + '/' + userId + '/' + customerNumber;// `${ConfigService.APIs.endPoints.FREIGHT_CLAIM.GET_MY_SHIPPED_ORDERS}` + "\\" + customerNumber;
    return ApiService.genericObservableGet(this.httpClient, endPoint)
      .pipe(
        catchError((err, caught) => { return throwError(err); }),
        map((response: BaseResponse) => { let result: any; result = response.data; return result; })//handle edge cases
      );
  }

  public getMyClaimsDetailsForProcessing(claimId): Observable<FreightClaimHeader> {
    let customerNumber = this.readUserObject.customerNumber;
    let userId = this.readUserObject.userId;
    const endPoint = '/FreightClaim/GetClaimDetailsForProcessing/' + claimId + '/' + userId + '/' + customerNumber;// `${ConfigService.APIs.endPoints.FREIGHT_CLAIM.GET_MY_SHIPPED_ORDERS}` + "\\" + customerNumber;
    return ApiService.genericObservableGet(this.httpClient, endPoint)
      .pipe(
        catchError((err, caught) => { return throwError(err); }),
        map((response: BaseResponse) => { let result: any; result = response.data; return result; })//handle edge cases
      );
  }

  public submitClaim(claim: FreightClaimHeader): any {
    let customerNumber = this.readUserObject.customerNumber;
    const endPoint = '/freightClaim/submitClaim';// `${ConfigService.APIs.endPoints.FREIGHT_CLAIM.GET_MY_SHIPPED_ORDERS}` + "\\" + customerNumber;   
    claim.raisedBy = this.readUserObject.userId;
    claim.raisedByUserEmail = this.readUserObject.userEmail;
    claim.customerNumber = +customerNumber;
    claim.customerName = this.readUserObject.customerName;
    return ApiService.genericObservablePost(this.httpClient, endPoint, claim)
      .pipe(
        catchError((err, caught) => { return throwError(err); }),
        map((response: BaseResponse) => response.data)
      );
  }


  public getClaimDetailsForUpdate(): Observable<Array<FreightClaimHeader>> {
    let customerNumber = this.readUserObject.customerNumber;
    let userId = this.readUserObject.userId;
    const endPoint = '/FreightClaim/GetMyClaims/' + userId + '/' + customerNumber;// `${ConfigService.APIs.endPoints.FREIGHT_CLAIM.GET_MY_SHIPPED_ORDERS}` + "\\" + customerNumber;
    return ApiService.genericObservableGet(this.httpClient, endPoint)
      .pipe(
        catchError((err, caught) => { return throwError(err); }),
        map((response: BaseResponse) => response.data)
      );
  }

  public getClaimDetailsForViewing(): Observable<Array<FreightClaimHeader>> {
    let customerNumber = this.readUserObject.customerNumber;
    let userId = this.readUserObject.userId;
    const endPoint = '/FreightClaim/GetMyClaims/' + userId + '/' + customerNumber;// `${ConfigService.APIs.endPoints.FREIGHT_CLAIM.GET_MY_SHIPPED_ORDERS}` + "\\" + customerNumber;
    return ApiService.genericObservableGet(this.httpClient, endPoint)
      .pipe(
        catchError((err, caught) => { return throwError(err); }),
        map((response: BaseResponse) => response.data)
      );
  }

  public getOpenClaims(): Observable<Array<FreightClaimHeader>> {
    let customerNumber = this.readUserObject.customerNumber;
    let userId = this.readUserObject.userId;
    const endPoint = '/FreightClaim/GetPendingClaims';// `${ConfigService.APIs.endPoints.FREIGHT_CLAIM.GET_MY_SHIPPED_ORDERS}` + "\\" + customerNumber;
    return ApiService.genericObservableGet(this.httpClient, endPoint)
      .pipe(
        catchError((err, caught) => { return throwError(err); }),
        map((response: BaseResponse) => response.data)
      );
  }

  public getAllClaims(): Observable<Array<FreightClaimHeader>> {
    let customerNumber = this.readUserObject.customerNumber;
    let userId = this.readUserObject.userId;
    const endPoint = '/FreightClaim/GetAllClaims';// `${ConfigService.APIs.endPoints.FREIGHT_CLAIM.GET_MY_SHIPPED_ORDERS}` + "\\" + customerNumber;
    return ApiService.genericObservableGet(this.httpClient, endPoint)
      .pipe(
        catchError((err, caught) => { return throwError(err); }),
        map((response: BaseResponse) => response.data)
      );
  }

  public updateClaim(claim: FreightClaimHeader): any {
    let customerNumber = this.readUserObject.customerNumber;
    const endPoint = '/freightClaim/UpdateClaim';// `${ConfigService.APIs.endPoints.FREIGHT_CLAIM.GET_MY_SHIPPED_ORDERS}` + "\\" + customerNumber;
    claim.raisedBy = this.readUserObject.userId;
    claim.customerNumber = +customerNumber;
    claim.customerName = this.readUserObject.customerName;
    return ApiService.genericObservablePost(this.httpClient, endPoint, claim)
      .pipe(
        catchError((err, caught) => { return throwError(err); }),
        map((response: BaseResponse) => response)
      );
  }

  setAdditionalProps(item) {
    this.setClaimedValue(item);
    this.setApprovedValue(item);
    this.setApprovedWeight(item);
  }
  setClaimedValue(item) {
    item.claimedValue = 0;
    if (item.claimedQuantity && item.unitPrice) {
      item.claimedValue = item.claimedQuantity * item.unitPrice;
    }
  }
  setApprovedValue(item) {
    item.approvedValue = 0;
    if (item.approvedQuantity && item.unitPrice) {
      item.approvedValue = item.approvedQuantity * item.unitPrice;
    }
  }
  setApprovedWeight(item) {
    item.approvedWeight = 0;
    if (item.approvedQuantity && item.itemWeight) {
      try {
        const n = Number.parseFloat(item.itemWeight);
        item.approvedWeight = item.approvedQuantity * n;
      }
      catch (e) { }
    }
  }
  setTotal(el: FreightClaimDetails) {
    el.totalApprovedValue = 0;
    el.totalApprovedWeight = 0;
    el.totalClaimedValue = 0;
    el.items.forEach((item, i) => {
      el.totalApprovedValue += item.approvedValue;
      el.totalApprovedWeight += item.approvedWeight;
      el.totalClaimedValue += item.claimedValue;
    });
  }

}
